<div (click)="preventReload($event)" id="google_translate_element"></div>
